var map = {
	"./maternity-care": [
		463,
		463
	],
	"./maternity-care.json": [
		463,
		463
	],
	"./mental-health": [
		646,
		646
	],
	"./mental-health.json": [
		646,
		646
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 353;
module.exports = webpackAsyncContext;